module.exports = __webpack_public_path__ + "img/productManager.b93f2ee3.png";